import { byInternet } from 'country-code-lookup'

export default function getCountryByCode(countryCode: string) {
	const country = byInternet(countryCode)
	return country ? country.country : 'Unknown'
}
